<template>
    <div class="bg-white rounded box-shadow p-1">
        <b-modal id="crop-modal" size="lg" title="Crops Information" hide-footer>
            <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="land_id">Select Land <span class="c-required">*</span></label>
                        <select v-model="crop_affected.land_id" @change="cclHide(crop_affected.land_id)" v-validate="'required'" id="land_id" name="land_id" class="form-control form-control-sm">
                            <option selected :value="''">Select Land</option>
                            <option v-for="(land, index) in lands" v-bind:value="land.id" :key="index">Land id : {{land.id }}, Mouza : {{land.mouza.mouza_desc }}, Plot: {{ land.plot_no }}, Land Ownership: {{land.land_ownership_type.land_ownership_type_desc }}</option>
                        </select>
                        <div class="invalid-feedback">
                            Please select valid land
                        </div>
                    </div>
                   <div class="col-md-6 col-sm-6 col-lg-4">
                      <label for="land_cultivation_id">Select Land Cultivation <span class="c-required">*</span></label>
                      <select v-model="crop_affected.land_cultivation_id" v-validate="'required'" id="land_cultivation_id" name="land_cultivation_id" class="form-control form-control-sm">
                        <option selected :value="''">Select Land Cultivation</option>
                        <option v-for="(land_cultivation, index) in land_cultivations" v-bind:value="land_cultivation.id" :key="index"> {{land_cultivation.id }}: {{land_cultivation.land_cultivation_desc }}</option>
                      </select>
                      <div class="invalid-feedback">
                        Please select valid land cultivation
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="crop_category_id">Crops <span class="c-required">*</span></label>
                        <select v-model="crop_affected.crop_category_id" v-validate="'required'" id="crop_category_id" name="crop_category_id"
                                class="form-control form-control-sm">
                            <option :value="''" selected>Select a crop</option>
                            <option v-for="(crop_category, index) in crop_categories" v-bind:value="crop_category.id" :key="index">{{ crop_category.id }} : {{crop_category.crop_category_desc }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            Please select a crop
                        </div>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="khatian_num">Khatian No.</label>
                        <input type="text" v-model="crop_affected.khatian_num" id="khatian_num" name="khatian_num" class="form-control form-control-sm" placeholder="Enter khatia no."/>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="cultivated_land">Cultivated affected land (decimal)</label>
                        <input type="number" v-model="crop_affected.cultivated_land" v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,4})?$/ }" id="cultivated_land" name="cultivated_land" class="form-control form-control-sm" placeholder="Enter cultivated affected land in decimal"/>
                        <div class="invalid-feedback">Cultivated affected land is number or integer</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="production">Production (Kg)</label>
                        <input type="number" v-model="crop_affected.production" v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,4})?$/ }" id="production" name="production" class="form-control form-control-sm" placeholder="Enter production"/>
                        <div class="invalid-feedback">Production (Kg) is number or integer</div>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="market_value">Present Market Value (Tk.)</label>
                        <input type="number" v-model="crop_affected.market_value" v-validate="{ regex: /^[0-9]*(?:\.[0-9]{0,4})?$/ }" id="market_value" name="market_value" class="form-control form-control-sm" placeholder="Enter market value"/>
                        <div class="invalid-feedback">Present market value (Tk.) is number or integer</div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="remarks">Amount</label>
                        <input type="number" v-validate="'max:10|decimal:4'" v-model="crop_affected.amounts" id="amounts" name="amounts" class="form-control form-control-sm" placeholder="Enter amount"/>
                        <span>{{ errors.first('amounts') }}</span>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <label for="remarks">Remarks</label>
                        <input type="text" v-model="crop_affected.remarks" id="remarks" name="remarks" class="form-control form-control-sm" placeholder="Enter remarks"/>
                    </div>
                </div>
               <div v-if="cclShow">
                <h5 class="modal-sub-header">CCL Information</h5>
                <div class="form-row">
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="ccl_id">CCL<span class="c-required">*</span></label>
                    <select v-model="crop_affected.ccl_id" v-validate="'required'"  @change="getCclInfo(crop_affected.ccl_id)"  id="ccl_id" name="ccl_id" class="form-control form-control-sm">
                      <option :value="''" selected>Select CCL</option>
                      <option v-for="(ccl_crop, index) in ccl_crops" v-bind:value="ccl_crop.id" :key="index">{{ ccl_crop.ccl_no }}</option>
                    </select>
                    <div class="invalid-feedback">Please select valid CCL</div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="ccl_amount" class="col-form-label col-form-label-sm">CCL Amount <span class="c-required">*</span></label>
                    <input type="number" v-model="crop_affected.ccl_amount" v-validate="{ max: 16,required: true, regex: /^[0-9]*(?:\.[0-9]{0,4})?$/ }" id="ccl_amount" name="ccl_amount" placeholder="CCL Amount" class="form-control form-control-sm"/>
                    <div class="invalid-feedback">Please provide valid CCL Amount</div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="cheque_date" class="col-form-label col-form-label-sm">Cheque Date</label>
                    <input type="text" disabled v-model="ccl.cheque_date" id="cheque_date" name="cheque_date" class="custom-select custom-select-sm"/>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="book_no" class="col-form-label col-form-label-sm">Book No</label>
                    <input type="text" disabled v-model="ccl.book_no" id="book_no" name="book_no" class="custom-select custom-select-sm"/>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="book_sub_no" class="col-form-label col-form-label-sm">Sub Book No</label>
                    <input type="text" disabled v-model="ccl.book_sub_no" id="book_sub_no" name="book_sub_no" class="custom-select custom-select-sm"/>
                  </div>
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <label for="amount" class="col-form-label col-form-label-sm">Total Amount</label>
                    <input type="text" disabled v-model="ccl.amount" id="amount" name="amount" class="custom-select custom-select-sm"/>
                  </div>
                </div>
              </div>
                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Crop</b-button>
                        <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Crop</b-button>
                        <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('crop-modal')">Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        props: ["crop_affected", "btn_edit", "cclShow"],

        components: {},
        data() {
            return {
                lands: [],
                crop_categories: [],
                data_ccl_crops: [],
                ccl_crops: [],
                land_cultivations: [],
                validation_errors: {},
                show: false,
                ccl: {},
            };
        },
        mounted() {
            this.getCodes();
        },
        methods: {
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/crops", this.crop_affected)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$emit("resetForm");
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$bvModal.hide("crop-modal");
                                    this.$emit("getPersonAffectedCrop");
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http.put("api/crops/" + this.crop_affected.id, this.crop_affected)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvModal.hide("crop-modal");
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.$emit("getPersonAffectedCrop");
                                }
                                if(response.data.error == true) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                                this.$bvToast.toast("Update Failed", {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            });
                    }
                });
            },
            getCodes() {
                let ses_id = this.$route.params.ses_id;
                http.get("api/getCropAffectedCodes/" + ses_id).then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.lands = data.lands;
                        this.crop_categories = data.crop_categories;
                        this.land_cultivations = data.land_cultivations;
                        this.data_ccl_crops = data.ccl_crops;
                    }
                });
            },
            cclHide(land_id) {
              this.lands.filter(function(elem) {
                if(elem.id === land_id)
                {
                  this.$emit("cclShowUpdate", elem.land_ownership_type_id == 1 ? true : false);
                }
              }.bind(this));
              this.getCclCrop(land_id);
            },
           getCclCrop(land_id) {
              let land = this.lands.find(l => l.id == land_id);

              var filteredArray = this.data_ccl_crops.filter(element =>
                  element.mouza_id === land.mouza_id
              )
              this.ccl_crops = filteredArray;
            },
          getCclInfo(ccl_id){
            let ccl_crop = this.ccl_crops.find(v => v.id == ccl_id);
            this.ccl.cheque_date = ccl_crop.cheque_date
            this.ccl.book_no = ccl_crop.book_no
            this.ccl.book_sub_no = ccl_crop.book_sub_no
            this.ccl.amount = ccl_crop.amount
            this.ccl.id = ccl_crop.id
          },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
    };
</script>
<style>
    .c-required {
        color: red;
    }
</style>
